/**
 * Created by Administrator on 2018/1/3.
 */

/*过滤器*/
//字数限定
let ellipsis = (str, num) => {
  if (typeof str != 'string' || str == null || str == '') return '';
  return str.length > num ? str.slice(0, num) + '...' : str;
}
//qq表情
let replace_em = (str) => {
  str = str.replace(/\</g, '&lt;');
  str = str.replace(/\>/g, '&gt;');
  str = str.replace(/\n/g, '<br/>');
  str = str.replace(/\[em_([0-9]*)\]/g, '<img src="../../static/dist/arclist/1.gif" border="0" />');
  return str;
}
//活动是否开始结束
let timeToMillion = (startStr, endStr)=> {
  var times;
  //如果是2个参数就是时间差
  if (endStr) {
    var startT = new Date(startStr).getTime()
    var endT = new Date(endStr).getTime()
    times = (endT - startT) / 1000
    // 如果是一个参数，参数值是秒数

  } else {
    times = startStr
  }
  var day, hour, minute,endOutStr;
  if (times > 0) {
    // console.log(times)
    day = Math.floor(times / (60 * 60 * 24));
    hour = Math.floor(times / (60 * 60)) - (day * 24);
    minute = Math.floor(times / 60) - (day * 24 * 60) - (hour * 60);
    // second = Math.floor(times) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
    if (parseInt(day) != 0) {
      if(day > 6){
        endOutStr = day + '天前'
      }else{
        endOutStr = day + '天' + hour + '小時' + minute + '分钟前'
      }

    } else {
      if (parseInt(hour) != 0) {
        endOutStr = hour + '小時' + minute + '分钟前'
      } else {
        endOutStr = minute + '分钟前'
      }
    }
  }else{
    endOutStr = 0
  }
  // if (day <= 9) day = '0' + day;
  // if (hour <= 9) hour = '0' + hour;
  // if (minute <= 9) minute = '0' + minute;
  // if (second <= 9) second = '0' + second;
  return endOutStr
}
let orderBys = (val,start) =>{
  var Time = new Date(val).getTime() - new Date().getTime()  /*+ 86400000*/;
  var Not = new Date().getTime() - new Date(start).getTime();
  var days;
  if (Not >= 0) {
    if (Math.ceil(Time / 1000 / 60 / 60 / 24) > 0) {
      var dayS =  Math.ceil(Time / 1000 / 60 / 60 / 24)
      if(dayS < 365){
        days = '剩余' + dayS + '天';
      }else{
        days = '长期有效'
      }

    } else {
      days = '活动已结束'
    }
  } else {
    days = '活动未开始'
  }
  return days
}
//活动是否开始结束
let orderBy = (val,start) =>{
  var Time = new Date(val).getTime() - new Date().getTime() /*+ 86400000*/;
  var Not = new Date().getTime() - new Date(start).getTime();
  var days;
  if (Not >= 0) {
    if (Math.ceil(Time / 1000 / 60 / 60 / 24) > 0) {
      var dayS =  Math.ceil(Time / 1000 / 60 / 60 / 24);
      if(dayS < 365){
        days = '剩余' + dayS + '天';
      }else{
        days = '长期有效'
      }

    } else {
      days = '活动已结束'
    }
  } else {
    days = '活动未开始'
  }
  return days
}
//活动是否显示时间
let orderByTime = (end,start) =>{
  var endTime = new Date(end).getTime() /*+ 86400000*/;
  var startTime = new Date(start).getTime();
  var dataTime = new Date().getTime();
  var days;
  if(((endTime - dataTime)/1000 / 60 / 60 / 24) > 365){
    days = '长期有效'
  }else if(endTime - startTime > 0){
    days = end + '结束'
  }else{
    days =  '已结束'
  }
  return days
}
//时分秒
let formatSeconds = value =>{
  var theTime = parseInt(value);// 秒
  var theTime1 = 0;// 分
  var theTime2 = 0;// 小时
  // alert(theTime);
  if(theTime > 60) {
    theTime1 = parseInt(theTime/60);
    theTime = parseInt(theTime%60);
    // alert(theTime1+'-'+theTime);
    if(theTime1 > 60) {
      theTime2 = parseInt(theTime1/60);
      theTime1 = parseInt(theTime1%60);
    }
  }
  var result = ''+parseInt(theTime);
  //分钟
  if(theTime1 > 0) {
    if(theTime1 >= 10){
      if(result >= 10){
        result = '00:'+parseInt(theTime1)+':'+result;
      }else{
        result = '00:'+parseInt(theTime1)+':0'+result;
      }
    }else{
      if(result >= 10){
        result = '00:0'+parseInt(theTime1)+':'+result;
      }else{
        result = '00:0'+parseInt(theTime1)+':0'+result;
      }
    }
  }else{
    if(result >= 10){
      result = '00:00:'+result;
    }else{
      result = '00:00:'+ '0' + result;
    }
  }
  if(theTime2 > 0) {
    if(theTime2 >= 10){
      result = parseInt(theTime2)+':' + result.substring(2);
    }else{
      result = '0' + parseInt(theTime2) + result.substring(2);
    }
  }else{

  }
  return result;
}
//评论时间
let TimeName= val =>{
  console.log(val)
  var days = Math.floor(val / 1000 / 60 / 60 / 24);
  var hour = Math.floor(val / 1000 / 60 / 60);
  var Minute = Math.floor(val / 1000 / 60);
  if (hour == 0) {
    return Minute + '分钟'
  } else if (days == 0) {
    return hour + '小时'
  } else {
    return days + '天前'
  }
}

//日期切割
let datetime = val =>{
  var n = '';
  if(val == null){
    n = 'null';
  }else{
    n = val.split(' ')[0];
  }
  return n
}
//活动状态
let status = val =>{
  if(val ==0){
    return '未开始'
  } else if(val == 1){
    return '活动中'
  }else if(val == 2){
    return '已结束'
  }
}
//票数
let ticket = val =>{
  var v = val / 10000;
  if (v > 1) {
    return v.toFixed(2) + '万票'
  } else {
    return Number(val) + '票'
  }
}
let format = (dateStr='') =>{
  return dateStr.replace(/\//g,'-');
}
export {
  orderByTime,
  replace_em,
  ellipsis,
  orderBy,
  orderBys,
  formatSeconds,
  datetime,
  status,
  ticket,
  timeToMillion,
  format,
  }



// WEBPACK FOOTER //
// ./src/router/filters.js